import {
 Toast,
 ToastProvider,
 ToastViewport,
 ToastTitle,
 ToastDescription,
 ToastClose,
} from './toast';
import { useToast } from '@/hooks/use-toast';
import { cn } from '@/lib/utils';

export function Toaster() {
 const { toasts } = useToast();

 return (
  <ToastProvider>
   {toasts.map(function ({
    id,
    title,
    description,
    action,
    variant,
    ...props
   }) {
    return (
     <Toast key={id} variant={variant} {...props}>
      <div className='flex gap-3 items-start'>
       <div
        className={cn(
         'mt-0.5 px-1.5 py-0.5 text-[8px] font-bold border',
         variant === 'destructive'
          ? 'border-destructive/30 text-destructive bg-destructive/10'
          : 'border-primary/30 text-primary bg-primary/10'
        )}
       >
        {variant === 'destructive' ? 'ERR' : 'LOG'}
       </div>
       <div className='grid gap-1'>
        {title && <ToastTitle>{title}</ToastTitle>}
        {description && <ToastDescription>{description}</ToastDescription>}
       </div>
      </div>
      {action}
      <ToastClose />
     </Toast>
    );
   })}
   <ToastViewport />
  </ToastProvider>
 );
}
